import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  animation: fadeIn 300ms;
`;
